import { PlayerComponentCSSStyleImpl } from '../../../../../../ui/toolkit/player/playercss';

export class MyToneCardPlayerCSSStyleImpl extends PlayerComponentCSSStyleImpl
{
    getPlayDivCSSStyle(): object 
    {
        return {
            // display: "flex",
            // textAlign: "center",
            // alignItems: 'center', 
            // justifyContent: 'center', 
            // position: "absolute",
            // marginTop: "20px",
            top:'5px',
            marginLeft:"10px",
            // marginRight: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"0px":'22px',
            cursor: "pointer",
            width: "30px",
            height: "30px",
            position:'absolute',
            ovalShadow: "0 0 8px 0 rgba(0,0,0,0.2)"
        };
    }

    getPlayIconCSSStyle(): object 
    {
        return {
            cursor: "pointer",
            height: "30px",
            width: "30px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/mytonescard/mytonecardplayercss.tsx